import { FC } from 'react';

import { SvgIcon, SxProps, useTheme } from '@thirdspacelearning/library';

interface Props {
    sx?: SxProps;
}

const LoCompleteIcon: FC<Props> = ({ sx }) => {
    const theme = useTheme();

    return (
        <SvgIcon
            width="80"
            height="80"
            viewBox="0 0 80 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={sx}
            data-testid="learning-objective-complete-icon"
        >
            <circle cx="40" cy="40" r="40" fill="#CBF9C4" />
            <path
                d="M40.2135 12.16C24.7842 12.16 12.1602 24.784 12.1602 40.2133C12.1602 55.6426 24.7842 68.2666 40.2135 68.2666C55.6428 68.2666 68.2668 55.6426 68.2668 40.2133C68.2668 24.784 55.6428 12.16 40.2135 12.16ZM40.2135 62.656C27.842 62.656 17.7708 52.5848 17.7708 40.2133C17.7708 27.8418 27.842 17.7706 40.2135 17.7706C52.585 17.7706 62.6562 27.8418 62.6562 40.2133C62.6562 52.5848 52.585 62.656 40.2135 62.656ZM54.9001 29.6367C53.9015 28.631 52.2756 28.6281 51.2734 29.6303L35.0545 45.8492C34.8049 46.0988 34.4004 46.0992 34.1503 45.8501L29.1472 40.8663C28.1469 39.8699 26.5287 39.8714 25.5303 40.8698L25.1917 41.2084C24.1919 42.2082 24.1919 43.8291 25.1917 44.8288L32.7926 52.4298C33.7924 53.4295 35.4133 53.4295 36.413 52.4298L55.2417 33.6011C56.2389 32.6039 56.2418 30.9879 55.2481 29.9871L54.9001 29.6367Z"
                fill={theme.palette.success.main}
            />
        </SvgIcon>
    );
};

export default LoCompleteIcon;
